import { previewDateHints } from './constants'

const getSingleBlockHint = ([block]) => {
  const key = block.isActive ? previewDateHints.singleActive : previewDateHints.singleInactive

  return { key, values: { block: block.name } }
}

const getTwoBlocksHint = blocks => {
  const [firstBlock, secondBlock] = blocks
  const activeBlock = blocks.find(block => block.isActive)
  const inactiveBlock = blocks.find(block => !block.isActive)
  const names = { firstBlock: firstBlock.name, secondBlock: secondBlock.name }

  if (!inactiveBlock) return { key: previewDateHints.twoBlocksActive, values: names }
  if (!activeBlock) return { key: previewDateHints.twoBlocksInactive, values: names }

  return {
    key: previewDateHints.twoBlocksPartial,
    values: { activeBlock: activeBlock.name, inactiveBlock: inactiveBlock.name },
  }
}

const getManyBlocksHint = blocks => {
  const totalCount = blocks.length
  const activeCount = blocks.filter(block => block.isActive).length

  if (activeCount === totalCount) return { key: previewDateHints.allActive, values: { totalCount } }
  if (activeCount === 0) return { key: previewDateHints.noneActive, values: { totalCount } }

  return { key: previewDateHints.someActive, values: { activeCount, totalCount } }
}

export const getPreviewDateHint = dateLimitedBlocks => {
  if (dateLimitedBlocks.length === 0) return null
  if (dateLimitedBlocks.length === 1) return getSingleBlockHint(dateLimitedBlocks)
  if (dateLimitedBlocks.length === 2) return getTwoBlocksHint(dateLimitedBlocks)

  return getManyBlocksHint(dateLimitedBlocks)
}
